import { SupportedLanguages } from 'types/language';
import { StoreAction } from 'types/store';

export const SET_LANG = 'SET_LANG';
export type SetLang = StoreAction<typeof SET_LANG, SupportedLanguages>;
export const setLang = (lang: SupportedLanguages): SetLang => ({
  type: SET_LANG,
  payload: lang,
});
